import "./review.page.scss";

const Review = () => {
  return <div className="review-container">Page: Review</div>;
};

export default Review;
